import React from 'react'
import cx from 'classnames'
import styles from './Hero.module.scss'
import { Container } from 'react-grid-system'
import { Heading, Paragraph, Breadcrumb } from '~elements'
import Image from 'next/image'
import { AssetType, ButtonProps, RichTextType } from '~types'
import { Button } from '~elements'
import { isComponentOfType } from 'utils'
import { NEXT_IMAGE_QUALITY, XO_PATHNAME_TO_DISPLAYNAME } from '~constants'

interface HeroProps {
  backgroundImage?: AssetType
  ctaSection?: Array<ButtonProps>
  description?: RichTextType
  eyebrow?: string
  displayBreadcrumb?: boolean
  subTitle?: string
  subheadline?: string
  title: string
  isGalleryComponent?: boolean
  logo?: AssetType
}

const Hero = ({
  backgroundImage,
  ctaSection,
  description,
  eyebrow,
  displayBreadcrumb,
  title,
  subTitle = '',
  subheadline = '',
  isGalleryComponent,
  logo
}: HeroProps) => {
  const headlineHasLogo = logo?.url
  const textJustification = headlineHasLogo ? 'left' : 'center'
  const H1Heading = (
    <Heading
      level={1}
      levelDisplay={headlineHasLogo ? 1 : 'display-lg'}
      justify={textJustification}
      noMarginBottom
      noMarginTop
    >
      {title}
    </Heading>
  )

  return (
    <div className={cx([styles['hero-container'], styles[logo ? 'has-logo' : '']])}>
      {displayBreadcrumb && (
        <div className={styles['breadcrumb-container']}>
          <Breadcrumb pathNameToDisplayName={XO_PATHNAME_TO_DISPLAYNAME} />
        </div>
      )}
      <div className={styles['hero']}>
        <Container
          // zIndex so it overlaps absolutely positioned gradient
          style={{ zIndex: 2 }}
        >
          {eyebrow && (
            <Heading level={6} justify={textJustification}>
              {eyebrow}
            </Heading>
          )}
          {headlineHasLogo ? (
            <div className={styles['title-with-logo']}>
              {H1Heading}
              <Image
                src={logo.url}
                alt={logo.altText || ''}
                width={logo.width}
                height={logo.height}
                quality={NEXT_IMAGE_QUALITY}
              />
            </div>
          ) : title ? (
            H1Heading
          ) : null}
          {subTitle && (
            <Heading level={2} justify={textJustification}>
              {subTitle}
            </Heading>
          )}
          {subheadline && (
            <Paragraph text={{ html: `<p>${subheadline}</p>` }} justify={textJustification} color='light' />
          )}
          {description && (
            <div className={styles['description-container']}>
              <Paragraph
                text={description}
                fontSize={logo ? 'md-plus' : 'lg'}
                justify={textJustification}
                color='light'
                noMarginBottom
              />
            </div>
          )}

          {ctaSection &&
            ctaSection.length > 0 &&
            ctaSection.map(button => {
              // @TODO: need to restrict ctaSection to Button only
              if (!isComponentOfType<ButtonProps>(button, 'Button')) return null

              return (
                <Button key={button.id} {...button} justify={textJustification} analytics={{ linkModule: 'hero' }} />
              )
            })}
        </Container>
      </div>

      {backgroundImage?.url && (
        <Image
          alt={backgroundImage?.altText || ''}
          src={backgroundImage.url}
          fill
          style={{
            opacity: `${isGalleryComponent || logo ? '1' : '.3'}`,
            objectFit: 'cover',
            objectPosition: 'top'
          }}
          quality={NEXT_IMAGE_QUALITY}
        />
      )}
    </div>
  )
}

export default Hero
